import * as React from 'react';

const ClimateImpact24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M14.846 3.679a8.153 8.153 0 0 1 0 16.306H6.703c-1.6 0-3.03-.537-4.066-1.52-1.039-.987-1.635-2.382-1.635-4.004 0-2.881 2.3-5.058 4.857-5.059.675 0 1.153.055 1.512.122.781-3.723 4.316-5.845 7.475-5.845m0 1.5c-2.798 0-5.814 2.024-6.109 5.34a.75.75 0 0 1-.934.66l-.2-.055c-.363-.103-.784-.222-1.744-.222-1.715 0-3.357 1.491-3.357 3.559 0 1.24.447 2.233 1.168 2.917.724.688 1.77 1.107 3.033 1.107h8.143a6.653 6.653 0 0 0 0-13.306"
  }
));
ClimateImpact24.Size = 24;
ClimateImpact24.Title = "ClimateImpact";

export { ClimateImpact24 as default };
